<template>
	<v-container >

		<v-snackbar v-model="snackbar" top :color="color" :timeout="3000" >  {{ text }}
		  <v-btn text dark @click.native="snackbar = false">Close</v-btn>
		</v-snackbar>

		<v-row >
			<v-col cols="12" md="9" lg="7">
				<v-card class="elevation-0" >
					<v-card-title primary-title>
					  Datos fiscales
					</v-card-title>
		      <v-card-text>
						
		        <v-form v-model="valid">
		          <v-row>
		          	<v-col cols="12" >
		              <v-text-field
		              	:readonly="readonly"
		              	required 
		              	v-model="nomcomer" 
		              	:rules="rulesGenerales" 
		              	clearable
		              	label="Nombre comercial"
										hide-details
										filled
										dense>
		              </v-text-field>
		            </v-col>
		            <v-col cols="12" sm="6" md="4" lg="4">
		              <v-text-field
		              	:readonly="readonly"
		              	:rules="rulesGenerales" 
		              	required 
		              	v-model="calle" 
		              	label="Calle"
										clearable
										filled 
										dense 
										hide-details>
		              </v-text-field>
		            </v-col>
		            <v-col cols="6" sm="3" md="4" lg="4">
		              <v-text-field
		              	:readonly="readonly"
		              	required 
		              	v-model="numint" 
		              	label="Num int"
		              	clearable
										filled
										dense
										hide-details>
		              </v-text-field>
		            </v-col>
		            <v-col cols="6" sm="3" md="4" lg="4">
		              <v-text-field
		              	:readonly="readonly" 
		              	required 
		              	v-model="numext" 
		              	label="Num ext"
		              	clearable
										filled
										dense
										hide-details>
		              </v-text-field>
		            </v-col>
		            <v-col cols="12" sm="6" md="6" lg="4">
		              <v-text-field
		              	:readonly="readonly"
		              	:rules="rulesGenerales" 
		              	required 
		              	v-model="colonia" 
		              	label="Colonia"
		              	clearable
										filled
										dense
										hide-details>
		              </v-text-field>
		            </v-col>
		            <v-col cols="7" sm="6" md="6" lg="5">
		              <v-text-field
		              	:readonly="readonly"
		              	:rules="rulesGenerales" 
		              	required 
		              	v-model="ciudad" 
		              	label="Ciudad"
		              	clearable
										filled
										dense
										hide-details>
		              </v-text-field>
		            </v-col>
								<v-col cols="5" sm="3" md="3" lg="3">
		              <v-text-field
		              	:readonly="readonly"
		              	:rules="rulesCP" 
		              	required 
		              	v-model="cp" 
		              	label="CP"
		              	clearable
										filled
										dense
										hide-details>
		              </v-text-field>
		            </v-col>
		            <v-col cols="6" sm="5" md="5" lg="6">
		              <v-text-field
		              	:readonly="readonly"
		              	:rules="rulesGenerales" 
		              	required 
		              	v-model="estado" 
		              	label="Estado"
		              	clearable
										filled
										dense
										hide-details>
		              </v-text-field>
		            </v-col>
		            <v-col cols="6" sm="4" md="4" lg="6">
		              <v-text-field
		              	:readonly="readonly"
		              	:rules="rulesGenerales" 
		              	required 
		              	v-model="pais" 
		              	label="Pais"
		              	clearable
										filled
										dense
										hide-details>
		              </v-text-field>
		            </v-col>
		            <v-col cols="12" sm="8" md="6" lg="6">
		              <v-text-field
		              	:readonly="readonly" 
		              	:rules="rfcRules"
		              	required
		              	v-model="rfc" 
		              	label="RFC"
		              	clearable
										filled
										dense
										hide-details>
		              </v-text-field>
		            </v-col>

		            <v-col cols="12" sm="4" md="6" lg="6">
		              <v-text-field
		              	:readonly="readonly" 
		              	required 
		              	v-model.number="telefono" 
		              	label="Teléfono"
		              	clearable
										filled
										dense
										hide-details
										type="number">
		              </v-text-field>
		            </v-col>
		            <v-col cols="12 " lg="12">
		              <v-text-field
		              	:readonly="readonly" 
		              	:rules="emailRules"
		              	required 
		              	v-model="email" 
		              	label="Email"
		              	clearable
										filled
										dense
										hide-details>
		              </v-text-field>
		            </v-col>
		          </v-row>
		        </v-form>
		      </v-card-text>

		      <v-card-actions>
		        <v-spacer></v-spacer>
		        <v-btn color="primary" @click="readonly= false">Editar</v-btn>
		        <v-btn color="secondary"  @click="save" :disabled="!valid">Grabar</v-btn>
		      </v-card-actions>
				</v-card>
	    </v-col>
	  </v-row>
	</v-container>
</template>

<script>
	import {mapGetters} from 'vuex'
  export default {
    data: () => ({
    	iddatosfis:'',
    	readonly: true,
    	valid: false,
      nomcomer:'',
			calle:'',
			numint:'',
			numext:'',
			colonia:'',
			ciudad:'',
			estado:'',
			cp:'',
			telefono:'',
			email:'',
			rfc:'',
			pais:'',
      modo:'',

      // reglas
      nameRules: [
        v => !!v || 'Name is requerido',
        v => v.length <= 10 || 'Name must be less than 10 characters',
      ],
      rulesGenerales: [
        v => !!v || 'es requerido',
        v => v.length <= 60 || 'No puedes exceder de los 60 caracteres',
      ],
      emailRules: [
        v => !!v || 'E-mail is requerido',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],

      rfcRules: [
        v => !!v || 'RFC is requerido',
        v => v.length <= 13 || 'RFC no puede exceder los 13 caracteres',
      ],

      rulesCP: [
        v => !!v || 'CP is requerido',
        v => v.length <= 6 || 'CP no puede exceder los 6 caracteres',
      ],

      snackbar: false,
      text:'',
      color:'',

    }),


    created () {
      this.initialize()
    },

    methods: {
      initialize () {
      	this.$http.get('datosfiscales.usuario/' + this.getdatosUsuario.idusuariosweb).then(response=>{
      		if(response.body == []){
      			this.modo = 1
      		}else{
      			this.modo = 2
      			this.calle = response.body[0].calle
      			this.pais = response.body[0].pais
	      		this.numint = response.body[0].numint
	      		this.numext = response.body[0].numext
	      		this.colonia = response.body[0].colonia
	      		this.ciudad = response.body[0].ciudad
	      		this.estado = response.body[0].estado
	      		this.cp = response.body[0].cp
	      		this.telefono = response.body[0].telefono
	      		this.rfc = response.body[0].rfc
	      		this.email = response.body[0].email
	      		this.nomcomer = response.body[0].nomcomer
	      		this.iddatosfis = response.body[0].iddatosfis
      		}
      	}).catch(error=>{console.log(error)})
        
      },


      save () {
      	if(this.readonly == false){

	      	var payload = {
	      		iddatosfis:     this.iddatosfis,
	      		calle:          this.calle,
	      		pais:           this.pais,
	      		numint:         this.numint,
	      		numext:         this.numext,
	      		colonia:        this.colonia,
	      		ciudad:         this.ciudad,
	      		estado:         this.estado,
	      		cp:             this.cp,
	      		telefono:       this.telefono,
	      		rfc:            this.rfc,
	      		email:          this.email,
	      		nomcomer:       this.nomcomer,
	      		idusuariosweb:  this.getdatosUsuario.idusuariosweb
	      	}

	      	if(this.modo == 1){
		      	console.log(payload)
		        this.$http.post('datosfiscales.add',payload).then(response=>{
		        	this.color="success"
		        	this.text= "Datos actualizados"
		        	this.snackbar = true
		        	this.readonly = true
		      		this.initialize()
		      	}).catch(error=>{console.log(error)})
	      	}else{
	      		this.$http.put('datosfiscales.update',payload).then(response=>{
	      			this.color="success"
	      			this.text= "Datos actualizados"
	      			this.snackbar = true
	      			this.readonly = true
		      		this.initialize()
		      	}).catch(error=>{console.log(error)})
	      	}

      	}
        
      },
    },

    computed:{
    	...mapGetters('login',['getdatosUsuario']),
    	tamanioDisplay () {
        console.log(this.$vuetify.breakpoint)
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return this.$vuetify.breakpoint.height - 250
          break;
          case 'sm': 
            return this.$vuetify.breakpoint.height - 250
          break;
          case 'md':
            return this.$vuetify.breakpoint.height - 250
          break;
          case 'lg':
            return this.$vuetify.breakpoint.height - 250 
          break;
          case 'xl':
            return this.$vuetify.breakpoint.height - 250
          break;
        }
      },
    }
  }
</script>